import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class RoadmapTableInitiativePlanningWeeklyGoalsController extends Controller {
  @service store;
  @service initiativeSlideover;

  get uncertainties() {
    return this.store
      .peekAll('uncertainty')
      .filter((item) => item?.initiative.get('id') === this.model.id);
  }

  @action
  handleSettingsSlideoverOpen() {
    this.initiativeSlideover.open(this.model.id);
  }
}
